import React from 'react';
import { motion } from 'framer-motion';
import Layout from '../components/Layout';
import ToolCard from '../components/ToolCard';
import { tools } from '../utils/toolsData';

const HomePage: React.FC = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <motion.div
        className="text-center mb-64"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-5xl font-bold text-textPrimary mb-16 leading-tight">
          텍스트 작업,
          <br />
          이제 쉽고 빠르게
        </h1>
        <p className="text-xl text-textSecondary mb-32">
          글자수부터 변환까지, 필요한 모든 텍스트 도구를 한 곳에서
        </p>
        <motion.button
          onClick={() =>
            document.getElementById('tools')?.scrollIntoView({ behavior: 'smooth' })
          }
          className="bg-primary text-white px-32 py-16 rounded-medium text-lg font-semibold"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          바로 시작하기
        </motion.button>
      </motion.div>

      {/* Tools Grid */}
      <div id="tools" className="mb-64">
        <h2 className="text-3xl font-bold text-textPrimary mb-32 text-center">
          모든 도구
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-24">
          {tools.map((tool, index) => (
            <motion.div
              key={tool.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
            >
              <ToolCard tool={tool} />
            </motion.div>
          ))}
        </div>
      </div>

      {/* Features Section */}
      <motion.div
        className="bg-surface rounded-large p-48 text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
      >
        <h2 className="text-2xl font-bold text-textPrimary mb-24">
          왜 TextKit을 선택해야 하나요?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-32">
          <div>
            <div className="text-4xl mb-16">⚡</div>
            <h3 className="text-lg font-bold text-textPrimary mb-8">
              빠른 속도
            </h3>
            <p className="text-textSecondary">
              클라이언트 사이드 처리로 즉시 결과 확인
            </p>
          </div>
          <div>
            <div className="text-4xl mb-16">🔒</div>
            <h3 className="text-lg font-bold text-textPrimary mb-8">
              개인정보 보호
            </h3>
            <p className="text-textSecondary">
              데이터가 서버로 전송되지 않습니다
            </p>
          </div>
          <div>
            <div className="text-4xl mb-16">🎯</div>
            <h3 className="text-lg font-bold text-textPrimary mb-8">
              심플한 UI
            </h3>
            <p className="text-textSecondary">
              복잡한 설명 없이 바로 사용 가능
            </p>
          </div>
        </div>
      </motion.div>
    </Layout>
  );
};

export default HomePage;
